export const productMasterSchema = {
	schema: {
		title: 'product master schema',
		description: 'Product Master Schema',
		version: 0,
		primaryKey: 'product_code',
		type: 'object',
		properties: {
			product_code: {
				type: 'string',
				maxLength: 250,
			},
			product_name: {
				type: 'string',
			},
			priority: {
				type: 'number',
			},
			image: {
				type: 'string',
			},
			unit: {
				type: 'string',
			},
			area_cover_by_unit: {
				type: 'number',
			},
			skus: {
				type: 'array',
				items: {
					type: 'object',
					properties: {
						id: { type: 'number' },
						sku_name: { type: 'string' },
						price: { type: 'number' },
						gst: { type: 'number' },
						quantity: { type: 'number' },
					},
				},
			},
			is_shade_applicable: {
				type: 'boolean',
			},
		},
		required: ['product_code', 'product_name', 'priority', 'image', 'unit', 'area_cover_by_unit', 'skus'],
	},
};
